import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Chip,
    Container,
    Divider,
    Link,
    Grid,
    Typography,
    Paper,
    TextField,
    Switch,
    FormGroup,
    FormControlLabel,
    MenuItem,
    Select,
    FormHelperText,
    Avatar,
    Checkbox
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import * as Yup from 'yup';
import DialogIcon from "../../../../components/kpi/DialogIcon";
import { useFormik } from 'formik';
import * as yup from 'yup';
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown.svg";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import * as Util from "../../../../services/global.service";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import currentEmployeesIcon from "../../../../assets/images/current-employee.svg";
import { currentEmployees, detailPosition } from "../../../../actions/admin";

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
};

const PositionDataDetail = (props) => {
    const { t } = useTranslation();
    const { state } = useLocation();

    useEffect(() => {
    }, []);

    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        input: {
            '& div > input': {
                height: '8px',
                position: "relative"
            }
        },

        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },
        disabled: {
            '& div > input': {
                height: '8px',
                position: "relative"
            },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            }
        },
        expandableIcon: {
            border: "1px solid #DADADA",
            // padding:" 8px",
            width: '20px',
            height: '20px',
            borderRadius: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: '.3s',
            transform: "rotate(90deg)",
            '&.active': {
                transform: "rotate(-90deg)",
            }
        },

    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false, state: { cycleID: state?.cycleID } });
    }
    const classes = useStyles();
    const dispatch = useDispatch();
    let { serial } = useParams();
    const [Data, setData] = React.useState({});
    const [status, setStatus] = React.useState(true);
    const [iconIcon, setIconIcon] = React.useState("");
    const [btnIcon, setBtnIcon] = React.useState("");
    const [colorIcon, setColorIcon] = React.useState("");
    const [openIcon, setOpenIcon] = React.useState(false);
    const [displayInactive, setDisplayInactive] = React.useState(false);
    const [backgroundColorValue, setBackgroundColorValue] = React.useState("#5DA196");
    const [backgroundColorStatus, setBackgroundColorStatus] = React.useState(false);
    const [errorText, seterrorText] = React.useState("");
    const [isCollapse, setCollapse] = React.useState(false);
    const [valueSerial, setValueSerial] = React.useState('');
    const handleStatus = () => {
        setStatus(!status)
    }

    const getDetailPosition = () => {
        dispatch(detailPosition(serial)).then(resp => {
            setData(resp.data.position)
        })
    }
    useEffect(() => {
        getDetailPosition()
    }, []);

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));

    const handleDisplayInactive = () => {
        setDisplayInactive(!displayInactive)
    }
    const handleCollapse = (data) => {
        // setCollapse(!isCollapse)
        if (data !== valueSerial) {

            setValueSerial(data)

        } else {

            setValueSerial("")

        }
    }

    return (
        <>
            <Helmet>
                <title>ADMIN | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/position-data')}>{t('admin.label.positionData')}</span> / <span style={styles.end} >{t('admin.label.viewPositionDataDetail')}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center" >
                            <Typography variant="h1" fontSize={36} lineHeight="53.82px" fontWeight="500" color="#404349">
                                {t('admin.label.viewPositionDataDetail')}
                            </Typography>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                <Box>
                                    <Button sx={{ display: "flex", height: "45px", "text-transform": "none" }} onClick={() => clickLink(`/admin/current-employees/${Data?.serial}`)} variant="dashed-solid" ><Box sx={{ display: "flex", "align-items": "center" }}><img style={{ display: "block", "margin-right": "10px" }} src={currentEmployeesIcon} alt="export"></img><Typography color="#393939">{t('admin.label.currentEmployees')}</Typography></Box></Button>
                                </Box>
                            </Box>
                        </Grid>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">
                            <Grid container item>
                                <Paper elevation={6} sx={{ 'border-radius': '10px', width: '100%' }} classes={{ root: classes.error }}>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "70px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.code')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Data?.code, "")} </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" display="flex">{t('admin.inputForm.status')} </Typography>
                                            <Box sx={{ paddingTop: "16px", height: "100%", "max-height": "55px", display: "flex", "align-items": "center" }}>
                                                <FormGroup >
                                                    <FormControlLabel
                                                        sx={{ m: 0,"pointer-events": "none" }}
                                                        control={<IOSSwitch checked={Data?.status === "active" ? true : false} onChange={() => handleStatus()} />}
                                                        label={Data?.status === "active" ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                                                    // disabled
                                                    />
                                                </FormGroup>
                                                {/* <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{status ? t('admin.inputForm.active') : t('admin.inputForm.inActive')} </Typography> */}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.positionNameEN')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Data?.name_en, "")} </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.positionNameTH')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Data?.name_th, "")}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.jobCode')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                {Data?.job !== undefined && Data?.job !== null && Object.keys(Data?.job).length > 0 ?
                                                    <Typography fontSize={16} lineHeight="23.92px">
                                                        {Util.formatData(Data?.job?.code, "")} {Data?.job?.code !== "" && Data?.job?.name !== "" ? " - " : ""} {Util.formatData(Data?.job?.name, "")}
                                                    </Typography>
                                                    : null
                                                }
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.lineGroup')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                {Data?.linegroup !== undefined && Data?.linegroup !== null && Object.keys(Data?.linegroup).length > 0 ?
                                                    <Typography fontSize={16} lineHeight="23.92px">
                                                        {Util.formatData(Data?.linegroup?.code !== "not_found" ? Data?.linegroup?.code : "" , "")} {Data?.linegroup?.code !== "" && Data?.linegroup?.code !== "not_found" && Data?.linegroup?.name !== "" && Data?.linegroup?.name !== "not_found" ? " - " : ""} {Util.formatData(Data?.linegroup?.name !== "not_found" ? Data?.linegroup?.name : "" , "")}
                                                    </Typography>
                                                    : null
                                                }
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.label.team')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                {Data?.team !== undefined && Data?.team !== null && Object.keys(Data?.team).length > 0 ?
                                                    <Typography fontSize={16} lineHeight="23.92px">
                                                        {Util.formatData(Data?.team?.code, "")} {Data?.team?.code !== "" && Data?.team?.name !== "" ? " - " : ""} {Util.formatData(Data?.team?.name, "")}
                                                    </Typography>
                                                    : null
                                                }
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.headOfOrganization')}</Typography>
                                            <Grid item display="flex" alignItems="center" mt={1}>
                                                <Checkbox color="primary" sx={{ pl: 0, pointerEvents: "none" }} checked={Data?.is_head_organization === true ? true : false} />
                                                <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('label.yes')}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.parentPostition')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                {Data?.position_parent !== undefined && Data?.position_parent !== null && Object.keys(Data?.position_parent).length > 0 ?
                                                    <Typography fontSize={16} lineHeight="23.92px">
                                                        {Util.formatData(Data?.position_parent?.code, "")} {Data?.position_parent?.code !== "" && Data?.position_parent?.name !== "" ? " - " : ""} {Util.formatData(Data?.position_parent?.name, "")}
                                                    </Typography>
                                                    : null
                                                }
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={6} sx={{ padding: "50px 0px 20px 40px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.startDate')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Util.dateDayFormat(Data?.start_date), "")} </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="26.91px" fontWeight={500}>{t('admin.inputForm.endDate')}</Typography>
                                            <Box sx={{ backgroundColor: "#FAFAFA", width: "100%", padding: "8px 15px", borderRadius: "4px", height: "40px" }} mt={1}>
                                                <Typography fontSize={16} lineHeight="23.92px">{Util.formatData(Util.dateDayFormat(Data?.end_date), "")}</Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    )
};
export default PositionDataDetail;
